import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { fToNow } from '@aibees/shared/utils';

export function aiAnalysisLatestUpdateDate(data?: PeopleTableInfo) {
  return fToNow(
    data?.revelation?.analysis?.content?.created ??
      data?.revelation?.analysis?.created
  );
}

export function doesAiAnalysisHasAnyUpdates(data?: PeopleTableInfo) {
  // A locked (never-unlocked) analysis can still carry backend ANALYSIS
  // change flags; those must not surface as updates until the user owns
  // an unlocked result.
  return isAiAnalysisUnlocked(data) && !!data?.changes?.ANALYSIS?.length;
}

export function isAiAnalysisUnlocked(data?: PeopleTableInfo) {
  return !!data?.revelation?.analysis?.content;
}
